export const CLEAR_SCANS = 'CLEAR_SCANS';
export const RECEIVE_SCANS_BY_PATIENT = 'RECEIVE_SCANS_BY_PATIENT';
export const UPDATE_SCAN = 'UPDATE_SCAN';
export const RECEIVE_SCAN = 'RECEIVE_SCAN';
export const RECEIVE_SCANS = 'RECEIVE_SCANS';
export const RECEIVE_SCAN_BY_PATIENT_INFO = 'RECEIVE_SCAN_BY_PATIENT_INFO';
